import { type NavigationAnchor } from "@/components/layout/types";
import {
  Module,
  PATH_PROJECT_DEPARTMENT_BASED_ASSIGNMENTS,
  PATH_SHIFT_REPORTS,
  PATH_TIMESHEET_ENTRIES,
  PATH_UPDATES,
  PATH_DICTS_DEPARTMENT_BASED_PROJECT_RATES,
} from "@/constants";
import { usePermissions } from "@/modules/account/hooks/usePermissions";
import {
  BadgeDollarSign,
  CalendarClock,
  CalendarRange,
  FolderClock,
  ReplaceAll,
} from "lucide-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useDepartmentBasedProjectMenuItems = (): NavigationAnchor[] => {
  const { t } = useTranslation();
  const permissions = usePermissions();

  return useMemo(
    () => [
      {
        icon: CalendarRange,
        url: PATH_UPDATES,
        // Using canExport as a proxy for read access,
        // since the whole module is just really an button with export capability.
        // No read, no write, just export.
        permission: permissions[Module.UpdatesPerWeek].can_export,
        title: t("updates.navigation.updates"),
      },
      {
        icon: ReplaceAll,
        url: PATH_SHIFT_REPORTS,
        permission: permissions[Module.ShiftReports].can_read,
        title: t("shiftReports.navigation.shiftReports"),
      },
      {
        icon: CalendarClock,
        url: PATH_TIMESHEET_ENTRIES,
        permission: permissions[Module.TimesheetEntries].can_read,
        title: t("timesheetEntries.navigation.timesheetEntries"),
      },
      {
        icon: FolderClock,
        url: PATH_PROJECT_DEPARTMENT_BASED_ASSIGNMENTS,
        permission: permissions[Module.DepartmentBasedAssignments].can_read,
        title: t("projects.navigation.assignContractors"),
      },
      {
        icon: BadgeDollarSign,
        url: PATH_DICTS_DEPARTMENT_BASED_PROJECT_RATES,
        permission: permissions[Module.DepartmentBasedProjectRates].can_read,
        title: t("departmentBasedProjectRates.title.multiple"),
      },
    ],
    [permissions, t],
  );
};
